import api from './api'

export default {
  getWallets(params = {}) {
    return api.get('/admin/billing/wallets', { params })
  },

  getWallet(companyId) {
    return api.get(`/admin/billing/wallets/${companyId}`)
  },

  adjustCredits(companyId, payload) {
    return api.post(`/admin/billing/wallets/${companyId}/adjust`, payload)
  },

  getPurchases(params = {}) {
    return api.get('/admin/billing/purchases', { params })
  },
}
